import { useContext } from 'react';
import { AppAuthContext } from '../contexts/AppAuthProvider';

const useAuth = () =>  useContext(AppAuthContext);

export default useAuth;